const altaProtocoloPcrInitialState = {
    altaProtocoloPcr: {
        loading: false,
        error: null,
        data: null
    },
};

export default altaProtocoloPcrInitialState;